import React from "react";
import { ContextLanguage } from "../../../context/Context.Language";
import {
  LAST_TIME_YOU_STILL_CAN_BOOK,
  RETURN_SAME_DAY,
  RETURN_SHOSE_TIME,
  RETURN_TIME,
  TIME_THAT_STILL_SAME_DAY_SERVICE,
} from "../../../utils/useConstants";

const FAQAboutTime = () => {
  const { language } = React.useContext(ContextLanguage);
  if (language === "TH") {
    return (
      <div>
        <span className="font-semibold">เวลาจัดส่ง:</span>{" "}
        สั่งออเดอร์ได้ทุกวันก่อน {LAST_TIME_YOU_STILL_CAN_BOOK}:00 น.
        แล้วเราจะไปรับทันที โดยปกติเร็วกว่า 60 นาที!
        เรารับประกันว่าจะส่งคืนทุกออเดอร์ในวันถัดไป: เสื้อผ้าและเครื่องนอนภายใน
        {RETURN_TIME}:00 น. รองเท้าหรือออเดอร์รวมผ้ากับรองเท้าภายใน{" "}
        {RETURN_SHOSE_TIME}:00 น. สะดวกและรวดเร็ว!
        เมื่อส่งคืนออเดอร์เรียบร้อยแล้ว เราจะส่งอีเมลแจ้งคุณทันที!
        <br />
        <br />
        <span className="font-semibold">เราสัญญาว่า</span>
        จะส่งคืนทุกออเดอร์ก่อนเวลาเสมอ หากออเดอร์เรียบร้อยแล้ว อย่างไรก็ตาม
        หากต้องการให้เรารับประกันส่งคืนภายใน {RETURN_SAME_DAY}:00 น.
        ของวันเดียวกัน กรุณาเลือกบริการส่งคืนด่วนในวันเดียวกันก่อน{" "}
        {TIME_THAT_STILL_SAME_DAY_SERVICE}:00 น.
      </div>
    );
  } else {
    return (
      <div>
        <span className="font-semibold">Timing:</span> Place your order any day
        of the week before {LAST_TIME_YOU_STILL_CAN_BOOK}:00, and we will come
        to pick it up immediately, typically in less than 60 mins! We GUARANTEE
        next-day return for all orders: Laundry by {RETURN_TIME}:00 noon, shoes
        or combined shoes & laundry orders by {RETURN_SHOSE_TIME}:00 - fast &
        easy! When your order is returned you will be instantly notified via
        mail!
        <br />
        <br />
        <span className="font-semibold">Express Service Promise:</span> We will
        always return your order ahead of schedule, whenever possible! However,
        for a GUARANTEED same-day return by {RETURN_SAME_DAY}:00, please
        activate our Same Day Express Service before{" "}
        {TIME_THAT_STILL_SAME_DAY_SERVICE}
        :00 noon.
      </div>
    );
  }
};

export default FAQAboutTime;
